const xogAfterGetData = async (id, data) => {
  if (data.images && Array.isArray(data.images)) {
    data.images.forEach(image => {
      if (image.title && typeof image.title === 'object') {
        Object.keys(image.title).forEach(lang => {
          if (typeof image.title[lang] === 'string') {
            image.title[lang] = image.title[lang].replace(/_/g, ' ');
          }
        });
      }
    });
  }
  return data;
}
